import { CommonModule } from '@angular/common';
import { Component, AfterViewInit } from '@angular/core';
import { Chart, ArcElement, Tooltip, Legend, Title, PieController } from 'chart.js';
import { SummaryService } from 'src/app/services/summary.service';
import { TranslationService } from 'src/app/services/translation.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { FormsModule } from '@angular/forms';

Chart.register(ArcElement, Tooltip, Legend, Title, PieController);

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [CommonModule,FormsModule],
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent {

  constructor(public translationService: TranslationService, private summaryService: SummaryService) { }

  userBranchId: number = 0;
  userBranchName: string = '';

  ngOnInit(): void {
    this.getUserBranchId();
   }

  selectedWidget: any = null;

  // Widgets
  candidateForToday: any[] = [];
  candidatesCurrentlyTesting: any[] = [];
  completedExamsToday: any[] = [];
  upcomingExamCandidates: any[] = [];


  totalStudents: number = 0;

  fromDate: string  = (() => {
    const d = new Date();
    d.setDate(d.getDate() + 2);
    d.setHours(0, 0, 0, 0);
      return d.toISOString().substring(0, 10); 
  })();

  toDate: Date = (() => {
    const d = new Date();
    d.setMonth(d.getMonth() + 12); 
    d.setHours(23, 59, 59, 999);
    return d;
  })();

  minDate: string = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().split('T')[0];

  selectedCourseFilter: string = '';
  selectedLangFilter: string = '';
  uniqueCourses: any[] = [];
  uniqueLanguages: any[] = [];



  widgets: { title: string; count: number; colorClass: string; data: any[] }[] = [
    { title: 'Candidates for Today', count: 0, colorClass: 'text-primary', data: [] },
    { title: 'Candidates Currently Testing', count: 0, colorClass: 'text-warning', data: [] },
    { title: 'Completed Exams Today', count:0, colorClass: 'text-success', data: [] },
    { title: 'Upcoming Exam Candidates', count: 0, colorClass: 'text-info', data: [] },
  ];
  
  getUserBranchId(){
    this.summaryService.getUserBranchId().subscribe((response) => {
      this.userBranchId = response.branchId;
      this.userBranchName = response.branchName;
      this.getTodayAssessments();
      this.getCandidatesCurrentlyTesting();
      this.getCompletedExamsToday();
      this.getUpcomingExamCandidates();
    });
  }

  getUserBranchName(){
    
  }

  getTodayAssessments() {
    this.summaryService.getTodayAssessments(this.userBranchId).subscribe(
      (response: any) => {
      if (response.length >= 1) {
        this.candidateForToday = [];
        response.forEach((course: { students: any[]; courseName: any; languageName: any; }) => {
          course.students.forEach((student: { nid: any; nameAr: any; phone: any; gender: any; assessmentDate: any; sessionName: any; sessionFrom: any; sessionTo: any; }) => {
            this.candidateForToday.push({
              id: student.nid,
              name: student.nameAr,
              phone: student.phone,
              courseName: course.courseName,
              language: course.languageName,
              gender: student.gender,
              examDate: student.assessmentDate,
              bookType: student.sessionName,
              sessionTime: `${student.sessionFrom} - ${student.sessionTo}`
            });
          });
        });
          this.widgets[0].data = this.candidateForToday;
          this.widgets[0].count = this.candidateForToday.length;
        } else {
          this.candidateForToday = [];
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  getCandidatesCurrentlyTesting(){
    this.summaryService.getCandidatesCurrentlyTesting().subscribe(
      (response: any) => {
        if (response.result[0].length >= 1) {
          this.candidatesCurrentlyTesting = response.result[0];
          this.widgets[1].data = this.candidatesCurrentlyTesting;
          this.widgets[1].count = this.candidatesCurrentlyTesting.length
          this.checkAndCreateCharts();
        } else {
          this.candidatesCurrentlyTesting = [];
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  getCompletedExamsToday(){
    this.summaryService.getCompletedExamsToday().subscribe(
      (response: any) => {
        if (response.result[0].length >= 1) {
          this.completedExamsToday = response.result[0];
          this.widgets[2].data = this.completedExamsToday;
          this.widgets[2].count = this.completedExamsToday.length
          this.checkAndCreateCharts();
        } else {
          this.completedExamsToday = [];
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  getUpcomingExamCandidates() {
    this.summaryService.getUpcomingExamCandidates(this.fromDate, this.toDate, this.userBranchId).subscribe(
      (response: any) => {
        if (response.length >= 1) {
          this.upcomingExamCandidates = [];
          response.forEach((course: { students: any[]; courseName: any; languageName: any; }) => {
            course.students.forEach((student: { nid: any; nameAr: any; phone: any; gender: any; assessmentDate: any; sessionName: any; sessionFrom: any; sessionTo: any; }) => {
              this.upcomingExamCandidates.push({
                id: student.nid,
                name: student.nameAr,
                phone: student.phone,
                courseName: course.courseName,
                language: course.languageName,
                gender: student.gender,
                examDate: new Date(student.assessmentDate),
                bookType: student.sessionName,
                sessionTime: `${student.sessionFrom} - ${student.sessionTo}`
              });
            });
          });
          this.widgets[3].data = this.upcomingExamCandidates;
          this.widgets[3].count = this.upcomingExamCandidates.length;

        } else {
          this.upcomingExamCandidates = [];
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
        this.upcomingExamCandidates = [];
      }
    );
  }
  
  selectWidget(widget: any) {
    this.selectedWidget = widget;
    this.totalStudents = widget.count;
    const data = widget.data || [];

    if (this.selectedWidget.title == 'Upcoming Exam Candidates' || this.selectedWidget.title ==  'Candidates for Today') {
      this.uniqueCourses = [...new Set(data.map((x: any) =>  x.courseName))];
      this.uniqueLanguages = [...new Set(data.map((x: any) =>  x.language))];
    }

    if (this.selectedWidget.title == 'Candidates Currently Testing' || this.selectedWidget.title ==  'Completed Exams Today') {
      this.uniqueCourses = [...new Set(data.map((x: any) =>  x.CourseName))];
      this.uniqueLanguages = [...new Set(data.map((x: any) =>  x.LanguageName))];
    }
  }

  closeModal() {
    this.selectedWidget = null;
    this.selectedCourseFilter = '';
    this.selectedLangFilter = '';
    this.uniqueCourses = [];
    this.uniqueLanguages = [];
  }
  
  get filteredCandidateForToday() {
    return this.candidateForToday.filter(student => {
      const courseMatch = this.selectedCourseFilter ? student.courseName === this.selectedCourseFilter : true;
      const langMatch = this.selectedLangFilter ? student.language === this.selectedLangFilter : true;
      return courseMatch && langMatch;
    });
  }

  get filteredCandidatesCurrentlyTesting() {
    return this.candidatesCurrentlyTesting.filter(student => {
      const courseMatch = this.selectedCourseFilter ? student.CourseName === this.selectedCourseFilter : true;
      const langMatch = this.selectedLangFilter ? student.LanguageName === this.selectedLangFilter : true;
      return courseMatch && langMatch;
    });
  }

  get filteredCompletedExamsToday() {
    return this.completedExamsToday.filter(student => {
      const courseMatch = this.selectedCourseFilter ? student.CourseName === this.selectedCourseFilter : true;
      const langMatch = this.selectedLangFilter ? student.LanguageName === this.selectedLangFilter : true;
      return courseMatch && langMatch;
    });
  }

  get filteredUpcomingExamCandidates() {
    const from = new Date(this.fromDate);
    from.setHours(0, 0, 0, 0);

    const to = new Date(this.toDate);
    to.setHours(23, 59, 59, 999); 

    const today = new Date();
    today.setHours(0, 0, 0, 0); 

    return this.upcomingExamCandidates.filter(student => {
      const examDate = new Date(student.examDate);
      examDate.setHours(0, 0, 0, 0); 

      const courseMatch = this.selectedCourseFilter ? student.courseName === this.selectedCourseFilter : true;
      const langMatch = this.selectedLangFilter ? student.language === this.selectedLangFilter : true;

      return courseMatch && langMatch &&
        examDate >= from && 
        examDate <= to; 
    });
  }


  checkAndCreateCharts(): void {
    this.createCharts();
  }

  createCharts(): void {
    if (typeof window !== 'undefined') {

      const courseCounts: { [key: string]: number } = {};
      this.candidatesCurrentlyTesting.forEach(candidate => {
        const course = candidate.CourseName || 'Unknown';
        courseCounts[course] = (courseCounts[course] || 0) + 1;
      });

      const labels = Object.keys(courseCounts);
      const values = Object.values(courseCounts);
      this.createPieChart('testResultsChart', labels, values);

      const passCount = this.completedExamsToday.filter(c => c.ExamResult === 'Passed').length;
      const failCount = this.completedExamsToday.filter(c => c.ExamResult === 'Failed').length;
      const total = passCount + failCount;

      const passPercent = total > 0 ? Math.round((passCount / total) * 100) : 0;
      const failPercent = total > 0 ? Math.round((failCount / total) * 100) : 0;

      this.createPieChart(
        'totalPassAndNotPass',
        ['Pass', 'Fail'],
        [passPercent, failPercent]
      );

    }
  }


  private createPieChart(chartId: string, labels: string[], data: number[]): void {
    const ctx = (document.getElementById(chartId) as HTMLCanvasElement).getContext('2d');
    if (ctx) {
      new Chart(ctx, {
        type: 'pie',
        data: {
          labels: labels,
          datasets: [{
            label: 'Distribution',
            data: data,
            backgroundColor: this.getChartColors(labels.length),
            borderColor: this.getChartColors(labels.length, true),
            borderWidth: 2,
          }]
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'top',
              labels: {
                font: {
                  size: 14,
                  weight: 'bold'
                },
                color: '#046F6D',
              }
            },
            tooltip: {
              callbacks: {
                label: function (tooltipItem) {
                  return `${tooltipItem.label}: ${tooltipItem.raw}%`;
                }
              },
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              bodyFont: {
                size: 14,
                weight: 'bold',
                family: 'Arial, sans-serif',
              }
            }
          },
          animation: {
            duration: 1000,
            easing: 'easeOutBounce',
          },
          cutout: 70,
          aspectRatio: 1,
        }
      });
    }
  }

  private getChartColors(count: number, isBorder: boolean = false): string[] {
    const colors = [
      'rgba(4, 111, 109, 0.6)',
      'rgba(239, 83, 80, 0.6)',
      'rgba(255, 193, 7, 0.6)',
      'rgba(33, 150, 243, 0.6)',
      'rgba(156, 39, 176, 0.6)',
      'rgba(0, 188, 212, 0.6)',
      'rgba(76, 175, 80, 0.6)',
      'rgba(255, 87, 34, 0.6)',
    ];

    const darkerColors = [
      'rgba(4, 111, 109, 1)',
      'rgba(239, 83, 80, 1)',
      'rgba(255, 193, 7, 1)',
      'rgba(33, 150, 243, 1)',
      'rgba(156, 39, 176, 1)',
      'rgba(0, 188, 212, 1)',
      'rgba(76, 175, 80, 1)',
      'rgba(255, 87, 34, 1)',
    ];

    return Array(count).fill(0).map((_, index) => {
      return isBorder ? darkerColors[index % darkerColors.length] : colors[index % colors.length]; 
    });
  }


  exportToExcel(): void {
    if (!this.selectedWidget || !this.selectedWidget.data || this.selectedWidget.data.length === 0) {
      console.error('No data available for export');
      return;
    }

    const data = this.selectedWidget.data;
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const headers = Object.keys(data[0]);

    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });
    worksheet['!cols'] = headers.map(() => ({ wch: 20 }));

    headers.forEach((header, idx) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: idx });
      if (!worksheet[cellAddress]) return;
      worksheet[cellAddress].s = {
        fill: { fgColor: { rgb: '28A745' } },
        font: { color: { rgb: 'FFFFFF' }, bold: true },
        alignment: { horizontal: 'center', vertical: 'center' }
      };
    });

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Exam Report': worksheet },
      SheetNames: ['Exam Report'],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
      cellStyles: true
    });

    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(blob, `${this.selectedWidget.title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`);
  }
}
